import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReviewQuestionnaire from '../../containers/Questionnaires/ReviewQuestionnaire';
import { withAuth } from '../../containers/Authenticated';

class ReviewQuestionnairePage extends React.Component {
  render() {
    return (<div id="home-tabs-navs-contents">
                <ReviewQuestionnaire id={ this.props.selectedQuestionnaireId } />
            </div>);
  }
}

ReviewQuestionnairePage.propTypes = {
  selectedQuestionnaireId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  selectedQuestionnaireId: state.questionnaires.selectedQuestionnaireId,
});

const ReviewQuestionnairePageWithAuth = withAuth(ReviewQuestionnairePage);

export default withRouter(connect(mapStateToProps)(ReviewQuestionnairePageWithAuth));